import Joi from 'joi';

const createList = {
  listName: Joi.string()
    .label('List Name')
    .min(3)
    .max(100)
    .required()
};

const createSegmentedList = {
  name: Joi.string()
    .label('Segmented List Name')
    .min(3)
    .max(100)
    .required(),
  segmentDefinition: Joi.object({
    valid: Joi.bool().valid(true),
    subConditionExpressions: Joi.array().min(1)
  })
};

export function getDynamicSubscriberList(mandatoryTextFields) {
  const subscriberFields = {};
  mandatoryTextFields.forEach(field => {
    let validator = Joi.string()
      .label(field.displayName)
      .required();
    
    if (field.name.toLowerCase().includes('email') || 
        field.displayName.toLowerCase().includes('email')) {
      validator = validator.email({ tlds: { allow: false } })
        .messages({
          'string.email': '{{#label}} must be a valid email address'
        });
    }
    
    if (field.name.toLowerCase().includes('phone') || 
        field.displayName.toLowerCase().includes('phone')) {
      validator = validator
        .pattern(/^(\+?1[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$|^(\+?91[-.\s]?)?[6-9]\d{9}$/)
        .messages({
          'string.pattern.base': 'Please enter a valid phone number'
        });
    }

    if (field.name.includes('firstName')) {
      validator = validator
        .max(255)
        .messages({
          'string.max': '{{#label}} must be less than 256 characters',
          'string.empty': '{{#label}} is required'
        });
    }

    if (field.name.includes('lastName')) {
      validator = validator
        .max(255)
        .messages({
          'string.max': '{{#label}} must be less than 256 characters',
          'string.empty': '{{#label}} is required'
        });
    }
    
    subscriberFields[field.name] = validator;
  });
  return Joi.object(subscriberFields);
}

export default {
  createList,
  createSegmentedList
};
